import { render, staticRenderFns } from "./ReportHeader.vue?vue&type=template&id=636074ae&scoped=true&"
import script from "./ReportHeader.vue?vue&type=script&lang=ts&"
export * from "./ReportHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ReportHeader.vue?vue&type=style&index=0&id=636074ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636074ae",
  null
  
)

export default component.exports